import { createRouter, AnyRoute } from "@tanstack/react-router";

import { Authentication, Dashboard, Root } from "@Routes";
import { NotFoundPage } from "@Elements";

const RouteTree = Root.RootRoute.addChildren([
  Dashboard.DashboardRouteTree,
  Authentication.AuthenticationRouteTree,
]);

export const Router = createRouter({
  routeTree: RouteTree,
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  defaultPreloadDelay: 100,
  defaultNotFoundComponent: NotFoundPage,
  context: {
    authentication: undefined,
    queryClient: undefined,
    translation: undefined,
  },
});

declare module "@tanstack/react-router" {
  interface Register {
    Router: typeof Router;
  }

  interface HistoryState {
    userId?: string;
  }

  interface StaticDataRouteOption {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TITLE?: any;
    PERMISSON_ID?: string;
    IS_LIST?: boolean;
    IS_BASE_ROUTE?: boolean;
    PARENT_ROUTE?: AnyRoute;
  }
}
